"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentCompleteDisplayFormat = void 0;
var PercentCompleteDisplayFormat;
(function (PercentCompleteDisplayFormat) {
    PercentCompleteDisplayFormat[PercentCompleteDisplayFormat["small"] = 1] = "small";
    PercentCompleteDisplayFormat[PercentCompleteDisplayFormat["medium"] = 2] = "medium";
    PercentCompleteDisplayFormat[PercentCompleteDisplayFormat["large"] = 3] = "large";
})(PercentCompleteDisplayFormat = exports.PercentCompleteDisplayFormat || (exports.PercentCompleteDisplayFormat = {}));
